import { appBaseName } from './constants';
import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import { routerMiddleware} from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';
import rootReducer from './reducers';
import Helpers from './helpers/util';

const loggerMiddleware = createLogger();
export const history = createHistory({
	basename:  appBaseName
});

const pushToGa = (dimension, value) => {
	if (value) {
		window.ga('set', dimension, value);
	}
}

const pushDimensions = (store) => {
	const { uid, profession, postcode } = store.getState().json.data.ga;
	pushToGa('dimension1', uid);
	pushToGa('dimension2', profession);
	pushToGa('dimension3', postcode);
}

// GA Page/route tracking
history.listen(() => {
	if (window.ga) {
		if (window.vaxiplace) {
			pushDimensions(store);
		}
	}
});

const initialState = {};

const store = createStore(
	rootReducer,
	initialState,
	applyMiddleware(
		thunkMiddleware,
		routerMiddleware(history),
		loggerMiddleware
	)
);

export default store;
